import * as actionType from 'redux/constants/rm'
import * as actionGeneral from './general'
import {apiCall} from 'service/apiCall'
import _ from "lodash";
import ExcelJS from 'exceljs/dist/es5/exceljs.browser.js'
import moment from 'moment'
import { saveAs } from 'file-saver'

import Cookie from 'universal-cookie'
const cookie=new Cookie()
const token=cookie.get('login_cookie')
const profile=cookie.get('profile_cookie')
export const setRm=(obj)=>async dispatch=>{
    dispatch({
        type:actionType.SET_RM,
        payload:obj
    })
}
export const getRmList=(slug)=>async(dispatch)=>{
    dispatch(actionGeneral.setLoadingTable(true))
    let dataReq={
        url:`/pipeline/list/rm${slug}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},

        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(_.get(res,'status')===200){
        dispatch(setRm({list_rm:res.data.items}))
        dispatch(setRm({pagination:res.data.info}))
        dispatch(actionGeneral.setLoadingTable(false))
        return res
    }else{
        dispatch(actionGeneral.setLoadingTable(false))

    }
}

export const postRm=(data)=>async(dispatch)=>{
    dispatch(actionGeneral.setLoading(true))
    let dataReq={
        url:`/pipeline/rm`,
        method:'POST',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
            data
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(_.get(res,'status')===200){
        dispatch(actionGeneral.modalToggle({ 
            modal_open: true,
            modal_title: "Relations Manager",
            modal_component: "add_rm",
            modal_size:400,
            modal_type:'alert',
            modal_data:{
                msg:`<p>Add RM successfully</p> `,
                ...res.data
            },
            modal_action:'success',
            // success_msg:success_msg
        }))
        dispatch(actionGeneral.setLoading(false))
        return res
    }else{
        dispatch(actionGeneral.setLoading(false))

    }
}

export const putRm=(data)=>async(dispatch)=>{
    dispatch(actionGeneral.setLoading(true))
    let dataReq={
        url:`/pipeline/rm/${data.id}`,
        method:'PUT',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
            data
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(_.get(res,'status')===204){
        dispatch(actionGeneral.modalToggle({ 
            modal_open: true,
            modal_title: "Relations Manager",
            modal_component: "add_rm",
            modal_size:400,
            modal_type:'alert',
            modal_data:{
                msg:`<p>Update RM successfully</p> `,
                ...res.data
            },
            modal_action:'success',
            // success_msg:success_msg
        }))
        dispatch(actionGeneral.setLoading(false))
        return res
    }else{
        dispatch(actionGeneral.setLoading(false))

    }
}

export const deleteRm=(id)=>async(dispatch)=>{
    dispatch(actionGeneral.setLoading(true))
    let dataReq={
        url:`/pipeline/rm/${id}/${profile.id}`,
        method:'DELETE',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(_.get(res,'status')===200){
        dispatch(actionGeneral.modalToggle({ 
            modal_open: true,
            modal_title: "Relations Manager",
            modal_component: "add_rm",
            modal_size:400,
            modal_type:'alert',
            modal_data:{
                msg:`<p>Delete RM successfully</p> `,
                ...res.data
            },
            modal_action:'success',
            // success_msg:success_msg
        }))
        dispatch(actionGeneral.setLoading(false))
        return res
    }else{
        dispatch(actionGeneral.setLoading(false))

    }
}


export const getDetailRm=(id)=>async(dispatch)=>{
    dispatch(actionGeneral.setLoading(true))
    let dataReq={
        url:`/pipeline/rm/${id}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},

        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(_.get(res,'status')===200){
        let {data}=res
        dispatch(setRm({
            detail_rm:{
                id:data.id,
                name:data.name,
                nik:data.nik,
                email:data.email,
                phone:data.phone,
                address:data.address,
                jobTitle:data.jobTitle,
                platformId:data.platform,
                segmentId:data.segment,
                branchId:data.branch,
                fileBase64:'',
                filename:'',
                file_url:data.fileUrl
            }
        }))
        dispatch(actionGeneral.setLoading(false))
        return res
    }else{
        dispatch(actionGeneral.setLoading(false))

    }
}
export const getExcelRm=(slug,name,year)=>async(dispatch)=>{
    dispatch(actionGeneral.setLoading(true))
    let dataReq={
        url:`/pipeline/export/visit${slug}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let resvisit=await dispatch(apiCall(dataReq))
    if(_.get(resvisit,'status')===200){
        const wb = new ExcelJS.Workbook()
        const sheet1 = wb.addWorksheet(`Sales visit`);
        let header=resvisit.data.headers
        var borderStyles = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
        };
        sheet1.getRow(1).values = [
            "No",
            "Company",
            "Contact Name",
            "Department",
            "Position",
            "Email",
            "Phone",
            "RM / Consultant",
            "Tribes",
            "Visit Date",
            "Location",
            "Visit Objective",
            "Next Step",
            "Remarks",
            "Last Updated"
        ]

        sheet1.columns = [
            { key: 'no', width: 5 },
            { key: 'company', width: 30 },
            { key: 'contactName', width: 25 },
            { key: 'department', width: 20 },
            { key: 'position', width: 20 },
            { key: 'email', width: 30 },
            { key: 'phone', width: 20 },
            { key: 'users', width: 30 },
            { key: 'tribes', width: 30 },
            { key: 'visitDate', width: 20 },
            { key: 'location', width: 15 },
            { key: 'objective', width: 15 },
            { key: 'nextStep', width: 15 },
            { key: 'remarks', width: 15 },
            { key: 'lastUpdated', width: 20 },
        ]
        resvisit.data.items.map((data)=>{

            const emails = [
                data.email1,
                data.email2,
                data.email3,
                data.email4
            ].filter(Boolean).join('\n')

            const phones = [
                data.phone1,
                data.phone2,
                data.phone3
            ].filter(Boolean).join('\n')

            const contactName = `${data.salutation || ''} ${data.name || ''}`.trim()

            

            const users = (data.users || '')
                .replace(/\r\n/g, '')
                .split(',')
                .map(x => x.trim())
                .filter(Boolean)
                .join('\n')

            sheet1.addRow({
                no: data.no,
                company: data.company,
                contactName: contactName,
                department: data.department,
                position: data.position,
                email: emails,
                phone: phones,
                users: users,
                tribes: data.tribes,
                visitDate: moment(data.visitDate).format('DD-MMM-YYYY'),
                location: data.location,
                objective: data.objective,
                nextStep: data.nextStep,
                remarks: data.remarks,
                lastUpdated: moment(data.lastUpdated).format('DD-MMM-YYYY HH:mm:ss'),
            })
        })
        sheet1.eachRow({ includeEmpty: true }, function (row) {
            row.eachCell({ includeEmpty: true }, function (cell) {
                cell.border = borderStyles
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                    wrapText: true
                }
            })
        })
        let dataReq={
            url:`/pipeline/export/proposal${slug}`,
            method:'GET',
            data:{
                headers:{ 'Authorization': `Bearer ${token}`},
            }
        }
        let res=await dispatch(apiCall(dataReq))
        if(_.get(res,'status')==200){
            dispatch(actionGeneral.setLoading(false))

            const sheet2 = wb.addWorksheet(`Proposal`);
            let header=res.data.headers
            var borderStyles = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            };
            sheet2.getRow(1).values=header

            sheet2.columns=[
                {key:'no',width:5},
                {key:'name',width:30},
                {key:'client',width:30},
                {key:'type',width:20},
                {key:'sentBy',width:15},
                {key:'sendDate',width:15},
                {key:'proposalValue',width:15},
                {key:'tribes',width:15},
                {key:'lastUpdated',width:20},
            ]
            res.data.items.map((data)=>{
                sheet2.addRow({
                    no:data.no,
                    name:data.name,
                    client:data.client,
                    type:data.type,
                    sentBy:data.sentBy,
                    sendDate:moment(data.sentDate).format('DD-MMM-YYYY'),
                    proposalValue:data.proposalValue,
                    tribes:data.tribes,
                    lastUpdated: moment(data.lastUpdated).format('DD-MMM-YYYY HH:mm:ss'),
                })
            })
            sheet2.eachRow({ includeEmpty: true }, function(row, rowNumber) {
                row.eachCell({ includeEmpty: true }, function(cell, colNumber) {
                    cell.border = borderStyles;
                    cell.alignment={ vertical: 'middle', horizontal: 'center' }
                });
            });
            const buf = await wb.xlsx.writeBuffer()

            saveAs(new Blob([buf]), `${name} sales visit & proposal ${year}.xlsx`)
        }else{
            dispatch(actionGeneral.setLoading(false))

        }
        return res
    }else{
        dispatch(actionGeneral.setLoading(false))

    }
}